import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  ContainerTable,
  Dialog,
  Header,
  TableHeader,
  Table,
  Text,
} from './styles';
import Dropdown from '../../../../core/layout-components/dropdown';

const UsersModal = (props) => {
  const {
    onClose,
    onOpenPasswordLink,
    show,
    users,
  } = props;

  return (
    <Container
      active={show}
      onClickOutside={onClose}
      page
    >
      <Dialog>
        <Header as="h1">Users</Header>

        <ContainerTable>
          <Table basic="very" fixed singleLine>
            <Table.Header>
              <Table.Row>
                <TableHeader>
                  Name
                </TableHeader>
                <TableHeader>
                  Email
                </TableHeader>
                <TableHeader> </TableHeader>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {!_.isEmpty(users) && _.map(users, (user) => {
                const {
                  id,
                  name,
                  email,
                } = user;

                return (
                  <Table.Row key={id}>
                    <Table.Cell>
                      <Text>{name}</Text>
                    </Table.Cell>

                    <Table.Cell>
                      <Text>{email}</Text>
                    </Table.Cell>

                    <Table.Cell>
                      <Dropdown scrolling inline header="Dropdown header" text="Actions">
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => onOpenPasswordLink(id)}>
                            Generate password link
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </ContainerTable>
      </Dialog>
    </Container>
  );
};

UsersModal.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  onClose: PropTypes.func.isRequired,
  onOpenPasswordLink: PropTypes.func,
  show: PropTypes.bool,
};

UsersModal.defaultProps = {
  show: false,
  onOpenPasswordLink: () => {},
};

export default UsersModal;
